import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";

export default function TemporaryDrawer(props) {
  const [state, setState] = React.useState(false);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState(open);
  };

  return (
    <React.Fragment>
      <Button
        sx={(theme) => ({
          zIndex: "1202",
          color: "white",
          [theme.breakpoints.up("md")]: {
            marginLeft: "auto",
          },
        })}
        onClick={toggleDrawer(state, true)}
      >
        {props.children[0]}
      </Button>
      <Drawer
        sx={{ zIndex: "1202" }}
        anchor={"right"}
        open={state}
        onClose={toggleDrawer(state, false)}
      >
        {/* {list(anchor)} */}
        <Box sx={{ width: "400px", height: "100%" }}>{props.children[1]}</Box>
      </Drawer>
    </React.Fragment>
  );
}
